import React from 'react';

const COLORS = { black: '#0A0A0A', white: '#F5F5F0', gold: '#C9A84C', gray: '#888' };

const DASHBOARD_URL = import.meta.env.VITE_DASHBOARD_URL || 'https://app.qrqy2.clawzie.xyz';

// TODO(M1): Check real auth session here — import session check from shared/auth
// TODO(M2): Wire Stripe Elements, validate session token from dashboard redirect
// TODO(M2): After successful payment, POST /api/orders and redirect to dashboard with claim token

function DisabledFormField({ label, placeholder }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
      <label style={{
        fontSize: '0.65rem',
        letterSpacing: '0.15em',
        color: 'rgba(255,255,255,0.3)',
        fontWeight: 600,
      }}>
        {label}
      </label>
      <input
        disabled
        placeholder={placeholder}
        style={{
          padding: '0.85rem 1rem',
          backgroundColor: 'rgba(255,255,255,0.03)',
          border: `1px solid rgba(255,255,255,0.08)`,
          color: 'rgba(255,255,255,0.2)',
          fontSize: '0.88rem',
          fontFamily: 'Inter, system-ui, sans-serif',
          cursor: 'not-allowed',
        }}
      />
    </div>
  );
}

export default function Checkout() {
  // TODO(M1): Replace with real auth state
  // Set VITE_MOCK_AUTH=true to enable checkout form for demos without a live API.
  const isAuthenticated = import.meta.env.VITE_MOCK_AUTH === 'true';

  return (
    <div style={{ maxWidth: '680px', margin: '0 auto', padding: '4rem 2rem' }}>
      <h1 style={{
        fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
        fontWeight: 900,
        letterSpacing: '-0.01em',
        color: COLORS.white,
        margin: '0 0 0.5rem',
      }}>
        CHECKOUT
      </h1>
      <div style={{
        height: '1px',
        backgroundColor: `rgba(255,255,255,0.08)`,
        margin: '0 0 3rem',
      }} />

      {/* Account activation gate */}
      <div style={{
        border: `1px solid ${COLORS.gold}`,
        padding: '2rem',
        marginBottom: '3rem',
      }}>
        <p style={{
          fontSize: '0.65rem',
          letterSpacing: '0.25em',
          color: COLORS.gold,
          fontWeight: 700,
          margin: '0 0 1rem',
        }}>
          ACTIVATE YOUR PIECE
        </p>
        <h2 style={{
          fontSize: '1.1rem',
          fontWeight: 800,
          letterSpacing: '0.04em',
          color: COLORS.white,
          margin: '0 0 0.75rem',
          lineHeight: 1.4,
        }}>
          A QRQY account is required to complete your purchase.
        </h2>
        <p style={{
          fontSize: '0.88rem',
          lineHeight: 1.7,
          color: COLORS.gray,
          margin: '0 0 1.75rem',
          fontFamily: 'Georgia, serif',
          fontStyle: 'italic',
        }}>
          This is how you own the link — not just the garment. Your account is your proof of
          ownership, your control panel, and your analytics dashboard. Sign in or create your
          account to continue. It takes 30 seconds.
        </p>

        {/* Premium benefit list */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '1px',
          backgroundColor: 'rgba(255,255,255,0.06)',
          marginBottom: '2rem',
        }}>
          {[
            { label: 'OWN YOUR LINK', desc: 'Your account is your proof of ownership — on-chain-grade permanence.' },
            { label: 'CHANGE ANYTIME', desc: 'Update where your QR points. No limit, no fee, instant.' },
            { label: 'SEE WHO SCANS', desc: 'Real analytics: scan counts, dates, and countries.' },
            { label: 'YOURS FOREVER', desc: 'Lifetime ownership. No subscription. No expiry.' },
          ].map(({ label, desc }) => (
            <div
              key={label}
              style={{
                padding: '1.1rem',
                backgroundColor: 'rgba(10,10,10,0.95)',
              }}
            >
              <p style={{
                fontSize: '0.6rem',
                letterSpacing: '0.2em',
                color: COLORS.gold,
                fontWeight: 700,
                margin: '0 0 0.4rem',
              }}>
                {label}
              </p>
              <p style={{
                fontSize: '0.75rem',
                color: COLORS.gray,
                margin: 0,
                lineHeight: 1.55,
                fontFamily: 'Georgia, serif',
                fontStyle: 'italic',
              }}>
                {desc}
              </p>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <a
            href={`${DASHBOARD_URL}/signup?redirect=${encodeURIComponent(typeof window !== 'undefined' ? window.location.href : '/checkout')}`}
            style={{
              display: 'inline-block',
              padding: '0.85rem 2rem',
              backgroundColor: COLORS.gold,
              color: COLORS.black,
              textDecoration: 'none',
              fontSize: '0.72rem',
              fontWeight: 800,
              letterSpacing: '0.18em',
              flex: 1,
              textAlign: 'center',
            }}
          >
            CREATE ACCOUNT
          </a>
          <a
            href={`${DASHBOARD_URL}/login?redirect=${encodeURIComponent(typeof window !== 'undefined' ? window.location.href : '/checkout')}`}
            style={{
              display: 'inline-block',
              padding: '0.85rem 2rem',
              backgroundColor: 'transparent',
              color: COLORS.white,
              textDecoration: 'none',
              border: `1px solid rgba(255,255,255,0.3)`,
              fontSize: '0.72rem',
              fontWeight: 700,
              letterSpacing: '0.18em',
              flex: 1,
              textAlign: 'center',
            }}
          >
            SIGN IN
          </a>
        </div>
      </div>

      {/* Checkout form — disabled until authenticated */}
      <div style={{ position: 'relative' }}>
        {/* Overlay when not authenticated */}
        {!isAuthenticated && (
          <div style={{
            position: 'absolute',
            inset: 0,
            zIndex: 10,
            backgroundColor: 'rgba(10,10,10,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(2px)',
          }}>
            <p style={{
              fontSize: '0.75rem',
              letterSpacing: '0.15em',
              color: 'rgba(255,255,255,0.5)',
              textAlign: 'center',
              padding: '0 2rem',
              fontWeight: 600,
            }}>
              COMPLETE ACCOUNT SETUP TO UNLOCK CHECKOUT
            </p>
          </div>
        )}

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2.5rem',
          opacity: isAuthenticated ? 1 : 0.3,
          pointerEvents: isAuthenticated ? 'auto' : 'none',
        }}>
          {/* Contact section */}
          <div>
            <p style={{
              fontSize: '0.65rem',
              letterSpacing: '0.2em',
              color: COLORS.white,
              margin: '0 0 1rem',
              fontWeight: 700,
            }}>
              CONTACT
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <DisabledFormField label="FULL NAME" placeholder="Your name" />
              <DisabledFormField label="EMAIL" placeholder="your@email.com" />
            </div>
          </div>

          {/* Shipping section */}
          <div>
            <p style={{
              fontSize: '0.65rem',
              letterSpacing: '0.2em',
              color: COLORS.white,
              margin: '0 0 1rem',
              fontWeight: 700,
            }}>
              SHIPPING
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <DisabledFormField label="ADDRESS LINE 1" placeholder="Street address" />
              <DisabledFormField label="ADDRESS LINE 2" placeholder="Apt, suite, unit (optional)" />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.75rem' }}>
                <DisabledFormField label="CITY" placeholder="City" />
                <DisabledFormField label="STATE" placeholder="State" />
                <DisabledFormField label="ZIP" placeholder="ZIP" />
              </div>
              <DisabledFormField label="COUNTRY" placeholder="United States" />
            </div>
          </div>

          {/* Payment section */}
          <div>
            <p style={{
              fontSize: '0.65rem',
              letterSpacing: '0.2em',
              color: COLORS.white,
              margin: '0 0 1rem',
              fontWeight: 700,
            }}>
              PAYMENT
            </p>
            {/* TODO(M2): Mount Stripe Elements here */}
            <div style={{
              padding: '1.5rem',
              border: `1px dashed rgba(255,255,255,0.1)`,
              textAlign: 'center',
            }}>
              <p style={{
                fontSize: '0.78rem',
                color: COLORS.gray,
                margin: 0,
                fontStyle: 'italic',
                fontFamily: 'Georgia, serif',
              }}>
                Stripe Elements will mount here in M2.
              </p>
            </div>
          </div>

          <button
            disabled
            style={{
              padding: '1.1rem',
              backgroundColor: COLORS.gold,
              color: COLORS.black,
              border: 'none',
              fontSize: '0.8rem',
              fontWeight: 800,
              letterSpacing: '0.2em',
              cursor: 'not-allowed',
              opacity: 0.5,
            }}
          >
            COMPLETE PURCHASE
          </button>
        </div>
      </div>
    </div>
  );
}
